<template>
    <div style="width: 100vw; height: 100vh;">
        <div class="weather">
            <div class="weather-info">
                <img v-if="currentWeatherData" width="50" :src="`https://openweathermap.org/img/w/${currentWeatherData.weather[0].icon}.png`"/>
                <span v-if="currentWeatherData">{{ Math.round(currentWeatherData.main.temp) }} °C -&nbsp;</span>
                <span>{{ device.city }}</span>
            </div>
            <span>
                <div class="license">OpenWeatherMap. <a target="_blank"
                        href="https://creativecommons.org/licenses/by-sa/4.0/" class="text-white">CC BY-SA 4.0</a></div>
            </span>
        </div>
        <div class="mural_carrossel">
            <div class="mural_slider"
                :style="`background: url('https://login.collab-tv.com/mural-admin/themes/${theme}.png') no-repeat; background-size: 100% 100%;`">
                <div class="mural_slider_left">
                    <div class="mural_slider_title">
                        {{ title }}
                    </div>
                    <div v-if="title" class="mural_slider_title_separator"></div>
                    <div class="mural_slider_text">
                        <div v-html="text"></div>
                    </div>
                </div>

                <div class="mural_slider_right">
                    <div v-for="(item, index) in medias" :key="'media_' + index"
                        :class="`mural_slider_right_block mural_slider_right_block_${template}`">
                        <img :src="item.localURL" />
                    </div>
                </div>
            </div>
        </div>
        <div class="mural_slider_bottom">
            <div class="mural_slider_bottom_time"></div>
        </div>
        <div class="clock">{{ formattedTime }}</div>
        <div class="credits-info">
            <div>v2.3.4 - 16/02/2023 • Last content update: {{ formattedLastUpdated }}</div>
            <div>© 2023 Mural Digital by CakeCherries. All rights reserved.</div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { mapState } from 'vuex'
import dayjs from 'dayjs'

export default {
    name: 'SlideT',

    props: {
        template: [String, Number],
        theme: [String, Number],
        title: String,
        text: String,
        medias: Array
    },

    watch: {
        currentTime(n, o){
            if (n && n !== o) {
                this.processTime()
            }
        }
    },

    computed: {
        ...mapState(['device', 'lastContentUpdate', 'currentWeatherData', 'currentTime']),

        formattedTime () {
            if (this.time) {
                return this.time.format('HH:mm')
            }
            return ''
        },

        formattedLastUpdated () {
            try {
                if (this.lastContentUpdate) {
                    return dayjs(this.lastContentUpdate).format('DD/MM/YYYY HH:mm')
                }
            } catch (error) {
                console.log(error)
            }
            return ''
        }
    },

    methods: {
        processTime () {
            let time = new Date(this.currentTime)
            let date = dayjs(time)
            let currentSeconds = time.getSeconds()

            this.time = date

            if (currentSeconds > 0) {
                let currentDeadlineSecondsInMiliseconds = (60 - currentSeconds) * 1000

                setTimeout(() => {
                    this.time = date.add('1', 'minute')
                    this.processInterval()
                }, currentDeadlineSecondsInMiliseconds)

                return
            }

            this.processInterval()
        },

        processInterval () {
            if(this.interval){
                clearInterval(this.interval)
            }

            this.interval = setInterval(() => {
                this.time = dayjs()
            }, 60000)
        }
    },

    beforeUnmount() {
        if(this.interval){
            clearInterval(this.interval)
        }
    },

    setup(){
        let interval = ref(null)
        let time = ref(null)

        return {
            interval,
            time
        }
    }
}
</script>
<style>
html,
body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-weight: 400;
    line-height: 1.5;
}

/* KEY FRAMES */
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
    }

    100% {
        -webkit-transform: rotate(360deg);
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* KEY FRAMES */

.mural_cover_layer {
    z-index: 99;
    background-color: #5DBFD4;
    width: 100vw;
    height: 100vh;
    opacity: 1;
    position: absolute;
}

.mural_cover_layer_spinner {
    border: 16px solid #5DBFD4;
    border-radius: 50%;
    border-top: 16px solid #242A75;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    /* Safari */
    animation: spin 2s linear infinite;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

.mural_cover_layer_noslide {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    opacity: 0;
    width: 20vw;
    height: 5vw;
}

.mural_cover_layer_noslide span {
    background-color: #FFF;
    display: inline-block;
    padding: 1vw;
    border-radius: 0.5vw;
}

.mural_cover_layer_noslide img {
    max-width: 100%;
}

.mural_carrossel {
    pointer-events: none;
}

.mural_slider {
    width: 100%;
    /* height: calc(100% - 33px); */
    height: 100%;
    position: absolute;
}

.mural_slider_left {
    float: left;
    width: 31%;
    max-width: 32%;
    min-width: 28%;
    margin-top: 17.5%;
    margin-left: 3%;
    text-align: left;
}

.mural_slider_title {
    font-family: UniviaPro;
    font-size: 2.8vw;
    color: #FFF;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    letter-spacing: 0.05vw;
    font-weight: 900;
}

.mural_slider_title_separator {
    height: 0.3vw;
    background-color: #FFF;
    width: 30%;
    max-width: 30%;
    min-width: 30%;
    margin-top: 2%;
    margin-bottom: 2.5%;
}

.mural_slider_text {
    font-family: UniviaPro !important;
    font-weight: 500;
    font-size: 1.7vw;
    color: #FFF;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    letter-spacing: 0.1vw;
}

.mural_slider_right {
    margin-left: 38.5%;
    margin-top: 9.3%;
    height: 38vw;
    width: 58vw;
    position: absolute;
}

.mural_slider_right_block {
    background-color: rgba(10, 23, 55, 0.3);
    -webkit-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.19);
    -moz-box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.19);
    box-shadow: 0px 0px 21px 0px rgba(0, 0, 0, 0.19);
}

.mural_slider_right_block img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    left: 50%;
    position: relative;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
}

.mural_slider_right_block_1 {
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
}

.mural_slider_right_block_2 {
    height: 17.88vw;
    width: 17.88vw;
    max-height: 17.88vw;
    max-width: 17.88vw;
    float: left;
    margin: 0vw 2.17vw 2.17vw 0vw;
}

.mural_slider_right_block_2:nth-child(3n) {
    margin: 0vw 0vw 2.17vw 0vw;
}

.mural_slider_right_block_2:nth-child(3n+1) {
    clear: both;
}

.mural_slider_right_block_3 {
    height: 100%;
    width: 48.13%;
    max-height: 100%;
    max-width: 48.13%;
    float: left;
    margin: 0vw 2.17vw 2.17vw 0vw;
}

.mural_slider_right_block_3:nth-child(2n) {
    margin: 0vw 0vw 2.17vw 0vw;
}

.mural_slider_right_block_4 {
    height: 47%;
    width: 100%;
    max-height: 47%;
    max-width: 100%;
    margin: 0vw 0vw 2.17vw 0vw;
}

.mural_slider_right_block_4:nth-child(2n) {
    margin: 0vw 0vw 0vw 0vw;
}

.mural_slider_right_block_5 {
    height: 8.15vw;
    width: 8.15vw;
    max-height: 8.15vw;
    max-width: 8.15vw;
    float: left;
    margin: 0vw 1.8vw 1.8vw 0vw;
}

.mural_slider_right_block_5:nth-child(6n) {
    margin: 0vw 0vw 1.8vw 0vw;
}

.mural_slider_right_block_5:nth-child(6n+1) {
    clear: both;
}

.mural_slider_bottom {
    bottom: 0;
    width: 100%;
    position: absolute;
    z-index: 999;
}

.mural_slider_bottom_time {
    margin: 0px 2vw 1.6vw 0px;
    float: right;
    font-family: UniviaPro;
    font-size: 2.6vw;
    color: #FFF;
}

.weather {
    font-family: UniviaPro;
    font-weight: 500;
    position: absolute;
    right: 2.1%;
    top: 5.5%;
    font-size: 2.0vw;
    color: #fff;
    z-index: 999;
    /*text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);*/
    text-shadow: 1px 1px #000;
}

.weather-info{
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
}

.weather .license {
    margin-top: -6px;
    font-size: .6vw;
    text-align: right;
    font-family: Questrial !important;
    font-weight: 100;
}

.weather .license a{
    text-decoration: none;
    color: #ffffff;
}

.clock {
    font-size: 3.4vw;
    right: 2%;
    /*text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.4);*/
    text-shadow: 1px 1px #000;
    font-family: UniviaPro;
    font-weight: 500;
    color: #fff;
    bottom: 2%;
    position: absolute;
    z-index: 999;
}

.credits-info{
    font-family: UniviaPro;
    text-shadow: 1px 1px #000;
    font-size: 11px;
    position: fixed;
    bottom: 2px;
    color: #ffffff;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    width: 99%;
    padding: 0 10px;
}
</style>
